import RequestService from '../request-service';

/**
 * get Player related settings from SB
 */
export default class PlayerInfoService extends RequestService {
  constructor() {
    super();

    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.playerInfo;
    // const { authorizationHeaders } = this.$config;
    this.addHeader('Provider', APP_SETTINGS.settings.userProviderId || 0);
    this.addHeader('Token', APP_SETTINGS.player.token);
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';
    /**
     * Get parameters
     * @type {{}}
     */
    this.getParams = {
    };
  }
}
